import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  CardActions,
  ListBase,
  Loading,
  useAuthenticated,
  useListContext,
  useTranslate,
} from "react-admin";
import { getLocalDate, getLocalTime } from "../../utils";
import { useEffect, useState } from "react";

import AddPotentialButton from "./components/AddPotentialButton";
import FilterDialog from "./components/FilterDialog";
import Phone from "../../components/Phone";
import PotentialInfoPanel from "./components/PotentialInfoPanel";
import SearchBarwithButton from "../../components/SearchBarwithButton";
import SfBreadcrumb from "../../components/SfBreadcrumbs";
import { useHistory } from "react-router-dom";

//import FilterPotentialButton from "./components/FilterPotentialButton";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: "100%",
    flex: "1 0 auto",
    marginTop: theme.defaultMarginTop,
    display: "flex",
  },
  title: theme.title,
  breadcrumb: {
    marginTop: 20,
    alignSelf: "start",
  },
  leftPanel: {
    backgroundColor: theme.default.normal.backgroundColor,
    width: "100%",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 0 auto",
  },
  rightPanel: {
    backgroundColor: "white",
    overflowY: "auto",
  },
  dataGrid_rowEven: {
    backgroundColor: "gray", //Not work
  },
  dataGrid_rowOdd: {
    backgroundColor: "red", //Not work
  },

  proceedButtonContainer: {
    backgroundColor: theme.default.normal.backgroundColor,
    width: "100%",
    height: 99,
    display: "flex",
    justifyContent: "center",
  },
  proceedButton: {
    width: 322,
    height: 57,
    fontSize: 28,
    fontWeight: "bold",
    alignSelf: "center",
    backgroundColor: theme.potentialBlue,
    color: theme.white,
  },

  searchButton: {
    backgroundColor: theme.potentialBlue,
    "&:hover": {
      backgroundColor: theme.darkBlue,
    },
  },
  searchandFilterContainer: {
    display: "grid",
    gridTemplateColumns: "400px 150px auto",
    columnGap: 8,
    alignItems: "center",
  },
}));

const PotentialList = (props) => {
  useAuthenticated();
  const translate = useTranslate();
  const classes = useStyles();
  const [potentialInfo, setPotentialInfo] = useState();
  const history = useHistory();
  const [foundUser, setFoundUser] = useState(false);
  const [displayFilter, setDisplayFilter] = useState(false);

  return (
    <Box className={classes.allContainer}>
      <Grid container>
        <Grid item xs={8} className={classes.leftPanel}>
          <SfBreadcrumb
            path="/Customer Insight/Potentials"
            className={classes.breadcrumb}
          />
          <Box
            style={{
              width: "100%",
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography className={classes.title} style={{ marginTop: 15 }}>
              {translate("ra.text.ci.selectPotentialCustomer")}
            </Typography>

            <ListBase
              {...props}
              resource="potentials"
              basePath="/ci/potential/search"
              bulkActionButtons={false}
              perPage={100}
              actions={<NoneActions />}
              style={{ width: "100%" }}
              sort={{ field: "None", order: "DSC" }}
            >
              <Box className={classes.searchandFilterContainer}>
                <Search />
                <AddPotentialButton />
                {
                  //  <FilterPotentialButton onClick={() => setDisplayFilter(true)} />
                }
              </Box>
              <MyDatagrid
                memberInfo={potentialInfo}
                setMemberInfo={setPotentialInfo}
                setFoundUser={setFoundUser}
              ></MyDatagrid>
            </ListBase>
            {foundUser ? (
              <Box className={classes.proceedButtonContainer}>
                <Button
                  className={classes.proceedButton}
                  variant="contained"
                  disabled={potentialInfo ? false : true}
                  onClick={() =>
                    history.push({
                      pathname: `/ci/potential/profiles/${potentialInfo.id}`,
                    })
                  }
                >
                  {translate("ra.text.proceed")}
                </Button>
              </Box>
            ) : null}
          </Box>
        </Grid>
        <Grid item xs={4} className={classes.rightPanel}>
          {potentialInfo ? (
            <PotentialInfoPanel
              firstname_th={potentialInfo.firstname}
              lastname_th={potentialInfo.lastname}
              firstname_en={potentialInfo.firstname}
              lastname_en={potentialInfo.lastname}
              phone={potentialInfo.phone}
              profileImage={potentialInfo.image_url}
              email={potentialInfo.email}
              birthdate={potentialInfo.birthdate}
              gender={potentialInfo.gender}
            />
          ) : null}
        </Grid>
      </Grid>
      <FilterDialog
        open={displayFilter}
        onClose={() => setDisplayFilter(false)}
      />
    </Box>
  );
};
const NoneActions = () => <CardActions />;

const handleClickMember = (record, setMemberInfo) => {
  setMemberInfo({ ...record });
};

const Search = () => {
  const { setFilters, filterValues } = useListContext();

  const translate = useTranslate();
  const classes = useStyles();
  return (
    <SearchBarwithButton
      onChange={(e) => {
        if (e.target.value === "") {
          const newFilterValues = { ...filterValues };
          delete newFilterValues.keyword;
          setFilters(newFilterValues);
        } else {
          setFilters({ ...filterValues, keyword: e.target.value });
        }
      }}
      placeholder={translate("ra.text.ci.searchMember")}
      onSearch={null}
      className={classes.searchButton}
      buttonLabel={translate("ra.action.search")}
    />
  );
};

const useMyDataGridStyles = makeStyles((theme) => ({
  tableContainer: {
    flexGrow: 1,
    flexBasis: 100,
    overflowY: "scroll",
  },
  loadingContainer: {
    flexGrow: 1,
    flexBasis: 100,
    overflowY: "none",
  },
  rowContainer: {
    backgroundColor: theme.white,
  },
  rowContainer_selected: {
    backgroundColor: theme.lightOrange,
  },
  rowHeight: { maxHeight: 68, paddingTop: 5, paddingBottom: 5, height: 68 },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  fullname: { ...theme.h7, width: 172 },
  time_text: { fontSize: 14 },
  point: {
    fontSize: 14,
    marginLeft: 4,
    color: theme.orange,
  },
  pointIcon: {
    width: 25,
    height: 25,
  },
  selectButton: {
    width: 89,
    height: 30,
  },
  titleTableText: {
    fontSize: 14,
  },
  tableHead: {
    height: 29,
  },
}));

const MyDatagrid = ({ memberInfo, setMemberInfo, setFoundUser }) => {
  const { data, ids, loading, filterValues } = useListContext();
  const classes = useMyDataGridStyles();
  const { setFilters } = useListContext();
  const translate = useTranslate();
  useEffect(() => {
    setFilters({});
    if (ids.length > 0) setFoundUser(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (ids?.length > 0) setFoundUser(true);
    else setFoundUser(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids]);
  if (loading) return <Loading className={classes.loadingContainer} />;

  return (
    <TableContainer className={classes.tableContainer}>
      <Table>
        {ids.length > 0 ? (
          <>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHead}>
                  <Typography className={classes.titleTableText} noWrap>
                    {translate("ra.text.ci.lastActivity")}
                  </Typography>
                </TableCell>
                <TableCell className={classes.tableHead}>
                  <Typography className={classes.titleTableText}>
                    {translate("ra.text.ci.nameandPhoneNumber")}
                  </Typography>
                </TableCell>

                <TableCell className={classes.tableHead}>
                  <Typography className={classes.titleTableText}>
                    {translate("ra.text.ci.tags")}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ids.map((id) => {
                const record = data[id];
                //const id = record.id;
                return (
                  <TableRow
                    key={id}
                    role="checkbox"
                    hover
                    onClick={() => handleClickMember(record, setMemberInfo)}
                    selected={memberInfo ? id === memberInfo.id : false}
                  >
                    {/* first column: selection checkbox */}
                    <TableCell className={classes.rowHeight}>
                      <Box className={classes.flexRow}>
                        <Box>
                          <Typography className={classes.time_text}>
                            {getLocalDate(record.last_transaction_time)}
                          </Typography>
                          <Typography className={classes.time_text}>
                            {getLocalTime(record.last_transaction_time)}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>

                    <TableCell className={classes.rowHeight}>
                      <Typography className={classes.fullname} noWrap>
                        {record.firstname} {record.lastname}
                      </Typography>

                      <Phone number={record.phone} />
                    </TableCell>

                    <TableCell className={classes.rowHeight}>
                      <Typography className={classes.point}>
                        {JSON.stringify(record.hashtags)}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </>
        ) : (
          <NotFoundView
            showError={
              filterValues?.keyword !== "" && filterValues.keyword !== undefined
            }
          />
        )}
      </Table>
    </TableContainer>
  );
};

const useNotFoundViewStyles = makeStyles((theme) => ({
  allContainer: {
    backgroundColor: theme.layoutBackground,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  redText: {
    marginTop: 17,
    color: theme.red,
    marginLeft: 72,
    marginRight: 72,
  },
  registerTitle: {
    marginTop: 93,
  },
  registerButton: {
    backgroundColor: theme.potentialBlue,
    marginTop: 26,
    width: 322,
    height: 57,
    fontSize: 18,
    lineHeight: "1.3rem",
    "&:hover": {
      backgroundColor: theme.darkBlue,
    },
  },
  or: {
    marginTop: 40,
  },
  addPaymentTitle: {
    marginTop: 24,
  },
  addPaymentButton: {
    marginTop: 14,
    width: 322,
    height: 57,
    fontSize: 28,
    backgroundColor: theme.potentialBlue,
  },
}));

const NotFoundView = ({ showError = true }) => {
  const classes = useNotFoundViewStyles();
  const translate = useTranslate();
  const history = useHistory();
  return (
    <Box className={classes.allContainer}>
      {showError ? (
        <Typography className={classes.redText} align="center">
          We cannot find this name. Please try again with phone number or
          register for new member
        </Typography>
      ) : (
        <Box />
      )}

      <Typography className={classes.registerTitle} align="center">
        Could not find the potential customer? Register for new potential
        customer here
      </Typography>
      <Button
        className={classes.registerButton}
        variant="contained"
        color="primary"
        onClick={() => history.push("/ci/potential/register")}
      >
        {translate("ra.text.ci.addPotential")}
      </Button>
    </Box>
  );
};

export default PotentialList;
